import React from 'react';

import styled from 'styled-components';

import {UserAvatar} from 'app/components/general/avatars';
import ElapsedTime from 'app/components/general/ElapsedTime';
import {gt} from 'app/utils/i18n';

import type {BasicUserSerializedType} from 'sweet-types';
const StyledContainerDiv = styled.div`
  background-color: rgba(230, 255, 234, 0.9);
`;

type Props = {
  versionApprovedAt: string;
  versionApprovedBy: BasicUserSerializedType;
};
export function ApprovedStamp({versionApprovedAt, versionApprovedBy}: Props) {
  return (
    <StyledContainerDiv className="border-bottom p-2">
      <div className="d-flex">
        <UserAvatar user={versionApprovedBy} showCard />
        <div className="ml-2">
          <div className="small">
            {gt('Approved by')} <b>{versionApprovedBy.name}</b>
          </div>
          <div className="small text-muted font-italic">
            <ElapsedTime timestamp={versionApprovedAt} tooltipPlacement="top" />
          </div>
        </div>
      </div>
    </StyledContainerDiv>
  );
}
